/* eslint-disable @reatom/unit-naming-rule */

import { WalletManagerRoute } from '@root/features/routing'
import { reatomCreateWalletFlow as reatomCreateWalletFlowCommon } from '@root/features/wallet/create-wallet/atoms'
import { routerActions } from '@root/shared/lib/react-router'

export const reatomCreateWalletFlow = () => {
  const model = reatomCreateWalletFlowCommon({
    onFinish: (ctx) => {
      routerActions.navigate(ctx, WalletManagerRoute.build())
    },
  })
  return {
    ...model,
  }
}
